import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useCollection from 'Hooks/useCollection';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';

import metaOverrideSetMap from 'Resources';

function CreateDialog({
  collection,
  metaOverrideSetName,
  onClose,
  onFailure,
  onSubmit,
  ...rest
}) {
  const {
    collection: coll,
    setCollection: setColl,
  } = useCollection();

  useEffect(() => {
    setColl(collection.create({
      metaOverrideSet: metaOverrideSetMap[metaOverrideSetName],
      addToNewCollection: true,
    }));
  }, []);

  if (!coll) {
    return null;
  }

  return (
    <MetaCollectionFormDialog
      open
      onClose={onClose}
      onSubmit={(res) => {
        if (onSubmit) {
          onSubmit(res);
        }
        onClose();
      }}
      onFailure={(err) => {
        if (onFailure) {
          onFailure(err);
        }
      }}
      collection={coll}
      title="Add Resource"
      {...rest}
    />
  );
}

CreateDialog.defaultProps = {
  metaOverrideSetName: null,
  onFailure: null,
  onSubmit: null,
};

CreateDialog.propTypes = {
  collection: PropTypes.object.isRequired,
  metaOverrideSetName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onFailure: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CreateDialog;
